// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"fdf1fea6","193":"7493f2b0","268":"d22da12d","403":"d91f31a4"}[chunkId] + ".chunk.js";
};